import { render, staticRenderFns } from "./DialogSettings.vue?vue&type=template&id=0f35ec03"
import script from "./DialogSettings.vue?vue&type=script&lang=js"
export * from "./DialogSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports